import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { clearModal } from '@shoflo/studio-redux/actions';
import ModalHeader from 'components/Modal/Header';
import { OVERLAY_TEMPLATES } from 'constants/ModalTypes';
import TemplateWrapper from 'containers/pages/Broadcast/Templates';
import { copyTemplate } from 'actions/Broadcast';

const OverlaysTemplates = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === OVERLAY_TEMPLATES
  );
  const dispatch = useDispatch();
  const clearThisModal = () => dispatch(clearModal(OVERLAY_TEMPLATES));
  const onSelectTemplate = template => {
    const payload = {
      type: template.type || 'overlays',
      title: template.name || template.key,
      isEventTemplate: template.isEventTemplate
    };
    if (template._id) {
      payload._id = template._id;
    }
    dispatch(copyTemplate(payload));
    clearThisModal();
  };

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      toggle={clearThisModal}
      data-testid="overlays-template-chooser-modal"
    >
      <ModalHeader>Add an overlay</ModalHeader>
      <ModalBody>
        <TemplateWrapper
          title={'overlays'}
          onCancel={clearThisModal}
          onSelectTemplate={onSelectTemplate}
        />
      </ModalBody>
    </Modal>
  );
};

export default OverlaysTemplates;
